import React, { useState } from "react";
import EnterPassword from "./password";
import EnterOTP from "../OTP/otp";
import {
  handleCompleteCustomAuth,
  handleCustomAuthLogin,
  handleForgotPasswordSubmit,
  handleForgotPassword,
} from "../../helper";
import NewPassword from "./newpassword";
import "./styles.scss";
import strings from "../../constants/strings";

export default function Login(props) {
  let {
    username,
    closeLoginModal,
    getLoggedInDetails,
    showSignUpModal,
    isMobile,
    handleFormInputChange,
    showAlert,
    askUsername,
  } = props;
  const [currentForm, setCurrentForm] = useState("password");
  const [otp, setOtp] = useState(null);
  const [loggedInUser, setUser] = useState(null);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [newPassword, setNewPassword] = useState(null);

  const handleNextOTPAction = async () =>
    isForgotPassword
      ? handleForgotPasswordSubmit(username, otp, newPassword)
          .then(() =>
            showAlert("Forgot Password", "Password changed successfully", true)
          )
          .then(() => closeLoginModal())
          .catch((error) =>
            showAlert(
              "Forgot Password",
              `${error.message}. Unable to reset password. Please try again`
            )
          )
      : handleCompleteCustomAuth(loggedInUser, otp)
          .then((user) => getLoggedInDetails(user))
          .then(() => showAlert("Login", "Logged in successfully", true))
          .then(() => closeLoginModal())
          .catch((error) =>
            showAlert(
              "Login",
              `${error.message}. Unable to send OTP. Please try again`
            )
          );

  const handleResendConfirmationCode = async () => {
    isForgotPassword
      ? handleForgotPassword()
          .then(() =>
            showAlert(
              "Forgot Password",
              "Forgot Password OTP re-sent successfully",
              true
            )
          )
          .catch((error) =>
            showAlert(
              "Forgot Password",
              `${error.message}. Unable to initiate login. Please try again`
            )
          )
      : handleCustomAuthLogin(username)
          .then(() =>
            showAlert("Login", "Login OTP re-sent successfully", true)
          )
          .catch((error) =>
            showAlert(
              "Login",
              `${error.message}. Unable to initiate login. Please try again`
            )
          );
  };

  function handleDisplayForm() {
    return {
      password: (
        <EnterPassword
          setUser={setUser}
          usernameInput={username}
          handleFormChange={(value) => setCurrentForm(value)}
          closeLoginModal={closeLoginModal}
          getLoggedInDetails={getLoggedInDetails}
          isMobile={isMobile}
          showSignUpModal={showSignUpModal}
          handleFormInputChange={handleFormInputChange}
          showAlert={showAlert}
          askUsername={askUsername}
        />
      ),
      newpassword: (
        <NewPassword
          setUser={setUser}
          usernameInput={username}
          showAlert={showAlert}
          setNewPassword={setNewPassword}
          handleFormChange={(value) => setCurrentForm(value)}
          setIsForgotPassword={setIsForgotPassword}
        />
      ),
      otp: (
        <EnterOTP
          otp={otp}
          handleChange={(value) => setOtp(value)}
          handleNext={handleNextOTPAction}
          handleFormChange={(value) => setCurrentForm(value)}
          buttonText={strings.LOGIN}
          handleResendConfirmationCode={handleResendConfirmationCode}
          showBack={true}
        />
      ),
    }[currentForm];
  }

  return <>{handleDisplayForm()}</>;
}
